module.exports = __webpack_public_path__ + "static/media/Icon-winter.305c5346.svg";